import { rollBossLoot, rollRaidLoot } from './loot.js';
/**
 * Shefira's loot for one raider (ADR 0068 §5, §6): what lies at her corpse
 * for them alone, once a game week. Always a piece of her set (`raid`
 * profile, `data/raid-gear.ts`), and the Frost Giant's share on top: the
 * materials and the chance of a snow piece a week's hardest fight owes.
 */
export function rollShefiraLoot(rng) {
    return [...rollRaidLoot(rng), ...rollBossLoot('snow', rng)];
}
//# sourceMappingURL=shefira-loot.js.map